<mat-dialog-content>
    <div style="text-align: center; padding: 10px; ">
        <div>
            <mat-icon class="rotate" style="font-size: 50px; color: #0070b0; width: 100%; height: 100%"
                      fontIcon="hourglass_empty">
            </mat-icon>
        </div>
        <b style="color: black;">Loading...</b>
    </div>
</mat-dialog-content>


